import { FIELD_NOTES, VIDEOS } from '../data/content'

export default function FieldNotes() {
  if (VIDEOS.length === 0) return null

  return (
    <section className="sheet notes" id="field-notes">
      <div className="container">
        <h2>{FIELD_NOTES.heading}</h2>
        <p className="lede">{FIELD_NOTES.intro}</p>
        <div className="note-list">
          {VIDEOS.map((video) => (
            <a key={video.youtubeId} className="note-link" href={`https://www.youtube.com/watch?v=${video.youtubeId}`}>
              <span>{video.title}</span>
              <time dateTime={video.date}>{video.date}</time>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
